<template>
    <section class="w-full overflow-hidden py-[40px] md:py-[56px] lg:py-[72px]">
        <div class="container">
            <div
                class="relative overflow-visible bg-[#FFC400] shadow-lg max-md:rounded-2xl md:rounded-s-[28px] before:hidden before:absolute before:left-full before:top-0 before:h-full before:w-screen before:-ml-px before:bg-[#FFC400] before:content-[''] lg:before:block"
            >
                <div
                    class="pointer-events-none absolute inset-0 overflow-hidden max-md:rounded-2xl md:rounded-s-[28px]">
                    <div
                        class="absolute -left-10 top-[-30px] h-[180px] w-[180px] rounded-full bg-white/20 blur-3xl"></div>
                    <div
                        class="absolute right-[18%] top-[20%] h-[220px] w-[220px] rounded-full bg-white/10 blur-3xl"></div>
                    <div
                        class="absolute bottom-[-40px] right-[8%] h-[180px] w-[180px] rounded-full bg-black/5 blur-3xl"></div>
                </div>

                <div class="relative md:h-[350px]">
                    <!-- DESKTOP / TABLET -->
                    <div class="hidden h-full lg:block">
                        <!-- ЛЕВАЯ СТАТИЧНАЯ ЧАСТЬ -->
                        <div
                            class="relative z-20 flex h-full w-[420px] flex-col justify-between ps-[56px] py-[60px]"
                        >
                            <div>
                                <div
                                    class="mb-4 inline-flex rounded-full border border-black/10 bg-white/35 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-black/70 shadow-sm"
                                >
                                    Нам доверяют
                                </div>

                                <h2
                                    class="max-w-[320px] text-4xl font-extrabold leading-[1.05] tracking-[-0.04em] text-black"
                                >
                                    Постоянные клиенты X-DEVS
                                </h2>

                                <p class="mt-2 max-w-[260px] text-xs font-semibold leading-[1.2] text-black/70">
                                    Сотрудничаем с партнёрами по всему миру и выстраиваем
                                    долгосрочные digital-решения для бизнеса.
                                </p>
                            </div>

                            <div class="mt-2 flex items-center gap-[18px]">
                                <button
                                    type="button"
                                    class="clients-slider-prev flex h-[52px] w-[52px] items-center justify-center rounded-full border border-black/15 bg-white/35 text-black shadow-sm transition hover:-translate-y-0.5 hover:bg-black hover:text-white hover:shadow-md"
                                    aria-label="Назад"
                                >
                                    <IconAngleLeft class="h-[18px] w-[18px]"/>
                                </button>

                                <button
                                    type="button"
                                    class="clients-slider-next flex h-[52px] w-[52px] items-center justify-center rounded-full border border-black/15 bg-white/35 text-black shadow-sm transition hover:-translate-y-0.5 hover:bg-black hover:text-white hover:shadow-md"
                                    aria-label="Вперед"
                                >
                                    <IconAngleLeft class="h-[18px] w-[18px] rotate-180"/>
                                </button>
                            </div>
                        </div>

                        <!-- ПРАВАЯ ДВИГАЮЩАЯСЯ СЦЕНА -->
                        <div class="absolute inset-y-0 left-[420px] right-0 z-10">
                            <div class="absolute left-0 top-0 h-full w-[980px] xl:w-[1080px] 2xl:w-[1160px]">
                                <Swiper
                                    :modules="modules"
                                    :slides-per-view="3"
                                    :slides-per-group="1"
                                    :space-between="28"
                                    :loop="true"
                                    :speed="850"
                                    :navigation="navigationOptions"
                                    class="clients-logos-swiper h-full"
                                >
                                    <SwiperSlide
                                        v-for="pair in logoPairs"
                                        :key="pair.id"
                                        class="h-full"
                                    >
                                        <div class="flex h-full flex-col justify-center gap-[24px] py-[40px]">
                                            <component
                                                :is="logo.link ? 'a' : 'div'"
                                                v-for="logo in pair.logos"
                                                :key="logo.id"
                                                :href="logo.link || null"
                                                :target="logo.link ? '_blank' : null"
                                                :rel="logo.link ? 'noopener noreferrer' : null"
                                                class="group flex h-[104px] min-h-[104px] items-center justify-center rounded-[24px] border border-black/10 bg-white/30 px-8 shadow-sm transition hover:-translate-y-1 hover:bg-white/40 hover:shadow-md"
                                            >
                                                <img
                                                    :src="logo.src"
                                                    :alt="logo.alt"
                                                    draggable="false"
                                                    class="block h-auto max-h-[54px] w-auto max-w-full select-none object-contain object-center opacity-80 transition duration-300 group-hover:opacity-100 [filter:invert(1)_grayscale(1)_brightness(0.12)] [-webkit-user-drag:none]"
                                                />
                                            </component>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>

                    <!-- MOBILE -->
                    <div class="flex flex-col px-7 py-8 lg:hidden">
                        <div>
                            <div
                                class="mb-4 inline-flex rounded-full border border-black/10 bg-white/35 px-3.5 py-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-black/70 shadow-sm"
                            >
                                Нам доверяют
                            </div>

                            <h2
                                class="text-2xl font-extrabold leading-[1.05] tracking-[-0.03em] text-black"
                            >
                                Постоянные клиенты<br/>X-DEVS
                            </h2>

                            <p class="mt-3 text-xs font-semibold leading-[1.5] text-black/70">
                                Сотрудничаем с партнёрами по всему миру и строим
                                долгосрочные digital-решения.
                            </p>
                        </div>

                        <div class="mt-8">
                            <Swiper
                                :modules="modules"
                                :slides-per-view="2"
                                :slides-per-group="1"
                                :space-between="16"
                                :loop="true"
                                :speed="850"
                                :navigation="mobileNavigationOptions"
                                class="clients-logos-swiper-mobile"
                            >
                                <SwiperSlide
                                    v-for="pair in logoPairs"
                                    :key="`mobile-${pair.id}`"
                                >
                                    <div class="flex flex-col gap-[16px]">
                                        <component
                                            :is="logo.link ? 'a' : 'div'"
                                            v-for="logo in pair.logos"
                                            :key="logo.id"
                                            :href="logo.link || null"
                                            :target="logo.link ? '_blank' : null"
                                            :rel="logo.link ? 'noopener noreferrer' : null"
                                            class="group flex h-[78px] min-h-[78px] items-center justify-center rounded-[18px] border border-black/10 bg-white/30 px-4 shadow-sm transition hover:bg-white/40"
                                        >
                                            <img
                                                :src="logo.src"
                                                :alt="logo.alt"
                                                draggable="false"
                                                class="block h-auto max-h-[40px] w-auto max-w-full select-none object-contain object-center opacity-80 transition duration-300 group-hover:opacity-100 [filter:invert(1)_grayscale(1)_brightness(0.12)] [-webkit-user-drag:none]"
                                            />
                                        </component>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>

                        <div class="mt-8 flex items-center gap-4">
                            <button
                                type="button"
                                class="clients-slider-prev-mobile flex h-[44px] w-[44px] items-center justify-center rounded-full border border-black/15 bg-white/35 text-black shadow-sm transition hover:bg-black hover:text-white"
                                aria-label="Назад"
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.9"
                                    class="h-[16px] w-[16px]"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M15 18l-6-6 6-6"
                                    />
                                </svg>
                            </button>

                            <button
                                type="button"
                                class="clients-slider-next-mobile flex h-[44px] w-[44px] items-center justify-center rounded-full border border-black/15 bg-white/35 text-black shadow-sm transition hover:bg-black hover:text-white"
                                aria-label="Вперед"
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.9"
                                    class="h-[16px] w-[16px]"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M9 6l6 6-6 6"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import {computed} from 'vue'
import {Navigation} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/vue'

import 'swiper/css'
import 'swiper/css/navigation'

import sagamet from '@img/clients/sagamet.png'
import m1 from '@img/clients/m1.png'
import karentrade from '@img/clients/karen-trade.png'
import lmkmoscow from '@img/clients/lmkmoscow.png'
import modaceramics from '@img/clients/ModaCeramics.png'
import digidealer from '@img/clients/DigiDealer.png'
import elektroskin from '@img/clients/electroskin.png'
import mskdemonazh from '@img/clients/msk-demontazh.png'
import vtorchermet from '@img/clients/vtorchermet.png'
import dorozhnyeplity from '@img/clients/dorozhnyeplity.png'
import IconAngleLeft from '@js/components/Icons/IconAngleLeft.vue'

const modules = [Navigation]

const navigationOptions = {
    prevEl: '.clients-slider-prev',
    nextEl: '.clients-slider-next',
}

const mobileNavigationOptions = {
    prevEl: '.clients-slider-prev-mobile',
    nextEl: '.clients-slider-next-mobile',
}

const logos = [
    {id: 1, src: sagamet, alt: 'SAGAMET', link: 'https://sagamet.ru'},
    {id: 2, src: m1, alt: 'Металлолом 1', link: 'https://metallolom1.ru'},
    {id: 3, src: dorozhnyeplity, alt: 'Dorozhnye Plity', link: 'https://dorozhnyeplity.ru'},
    {id: 4, src: lmkmoscow, alt: 'LMK', link: 'https://lmk-moscow.ru'},
    {id: 5, src: karentrade, alt: 'Karen Trade', link: 'https://karen-trade.com'},
    {id: 6, src: vtorchermet, alt: 'vtorchermet', link: 'https://vtorchermet-1.ru'},
    {id: 7, src: modaceramics, alt: 'Moda Ceramics', link: ''},
    {id: 8, src: mskdemonazh, alt: 'MSK Demontazh', link: 'https://msk-demontazh.ru'},
    {id: 9, src: digidealer, alt: 'DigiDealer', link: ''},
    {id: 10, src: elektroskin, alt: 'ElectroSkin Studio', link: ''},
]

const logoPairs = computed(() => {
    const pairs = []

    for (let i = 0; i < logos.length; i += 2) {
        pairs.push({
            id: `pair-${i}`,
            logos: logos.slice(i, i + 2),
        })
    }

    return pairs
})
</script>

<style scoped>
.clients-logos-swiper,
:deep(.clients-logos-swiper .swiper),
:deep(.clients-logos-swiper .swiper-wrapper),
:deep(.clients-logos-swiper .swiper-slide) {
    height: 100%;
}

.clients-logos-swiper-mobile,
:deep(.clients-logos-swiper-mobile .swiper),
:deep(.clients-logos-swiper-mobile .swiper-wrapper),
:deep(.clients-logos-swiper-mobile .swiper-slide) {
    height: auto;
}

:deep(.swiper-button-disabled) {
    opacity: 0.45;
    pointer-events: none;
}
</style>
